import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    providerId: String,
    providerName: String,
    category: String
  }

  connect() {
    this.scrollDepths = new Set()
    this.setupScrollTracking()
  }

  disconnect() {
    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler)
    }
  }

  // Track CTA button clicks (FR-025)
  trackCtaClick(event) {
    const ctaType = event.currentTarget.dataset.ctaType || 'default'
    if (window.ahoy) {
      window.ahoy.track('integration_page.cta_click', {
        provider_id: this.providerIdValue,
        provider_name: this.providerNameValue,
        category: this.categoryValue,
        cta_type: ctaType,
        cta_text: event.currentTarget.textContent.trim()
      })
    }
  }

  // Track FAQ expansion (FR-025)
  trackFaqExpand(event) {
    const question = event.currentTarget.dataset.question
    if (window.ahoy) {
      window.ahoy.track('integration_page.faq_expand', {
        provider_id: this.providerIdValue,
        provider_name: this.providerNameValue,
        category: this.categoryValue,
        question: question
      })
    }
  }

  // Track scroll depth at 25%, 50%, 75%, 100% (FR-025)
  setupScrollTracking() {
    const depths = [25, 50, 75, 100]

    this.scrollHandler = this.throttle(() => {
      const scrollPercent = Math.round((window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100)

      depths.forEach((depth) => {
        if (scrollPercent >= depth && !this.scrollDepths.has(depth)) {
          this.scrollDepths.add(depth)
          if (window.ahoy) {
            window.ahoy.track('integration_page.scroll_depth', {
              provider_id: this.providerIdValue,
              provider_name: this.providerNameValue,
              category: this.categoryValue,
              depth: depth
            })
          }
        }
      })
    }, 200)

    window.addEventListener('scroll', this.scrollHandler, { passive: true })
  }

  // Throttle helper to avoid performance issues
  throttle(func, limit) {
    let inThrottle
    return function throttled(...args) {
      if (!inThrottle) {
        func.apply(this, args)
        inThrottle = true
        setTimeout(() => { inThrottle = false }, limit)
      }
    }
  }
}
